module.exports = __webpack_public_path__ + "img/home.742dec52.jpg";